import { convertToCamelCase } from './caseConverter';
import sliderConfig from '../config/sliderConfig';

// Utility function to aggregate review data by position
export const aggregateReviewDataByPosition = (reviews) => {
    const aggregatedDataByPosition = {};

    reviews.forEach(review => {
        const camelCaseReview = convertReviewData(review);

        const attributes = camelCaseReview.attributes || {};
        const position = attributes.positionHeld?.value;
        const sliders = attributes.sliders || {};

        if (position) {
            if (!aggregatedDataByPosition[position]) {
                aggregatedDataByPosition[position] = {};
            }

            Object.keys(sliderConfig).forEach(field => {
                const value = sliders[field];
                if (typeof value === 'number') {
                    if (!aggregatedDataByPosition[position][field]) {
                        aggregatedDataByPosition[position][field] = { total: 0, count: 0 };
                    }
                    aggregatedDataByPosition[position][field].total += value;
                    aggregatedDataByPosition[position][field].count += 1;
                }
            });
        }
    });

    // Calculate averages for each position
    Object.keys(aggregatedDataByPosition).forEach(position => {
        Object.keys(aggregatedDataByPosition[position]).forEach(field => {
            const data = aggregatedDataByPosition[position][field];
            aggregatedDataByPosition[position][field] = data.count > 0 ? parseFloat((data.total / data.count).toFixed(1)) : 0;
        });
    });

    return aggregatedDataByPosition;
};

// Utility function to convert review data to camel case and handle sliderConfig fields
const convertReviewData = (review) => {
    const camelCaseReview = convertToCamelCase(review);
    // Additional processing can be done here if needed
    return camelCaseReview;
};
